import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    getvalidationserverMessages(errorResponse: HttpErrorResponse): string[] {
        const error = errorResponse?.error;

        if (Array.isArray(error)) {
            return error
                .map((message) => this.normalizeMessage(message))
                .filter((message): message is string => !!message);
        }

        if (Array.isArray(error?.errors)) {
            return error.errors
                .map((message: unknown) => this.normalizeMessage(message))
                .filter((message: string | undefined): message is string => !!message);
        }

        if (error?.errors && typeof error.errors === 'object') {
            return Object.values(error.errors)
                .flat()
                .map((message) => this.normalizeMessage(message))
                .filter((message): message is string => !!message);
        }

        return [];
    }

    getServerMessage(errorResponse: HttpErrorResponse): string {
        return this.getDefaultStatusMessage(errorResponse?.status);
    }

    private readonly getDefaultStatusMessage = (statusCode: number | undefined): string => {
        switch (statusCode) {
            case 0:
                return 'Unable to connect to the server. Please check your network connection.';
            case 400:
                return 'The request could not be processed. Please verify the entered information.';
            case 401:
                return 'Your session is not authorized. Please sign in again.';
            case 403:
                return 'You do not have permission to perform this action.';
            case 404:
                return 'The requested resource was not found.';
            case 405:
                return 'This action is not allowed for the requested resource.';
            case 408:
                return 'The request timed out. Please try again.';
            case 409:
                return 'The request could not be completed because of a conflict.';
            case 422:
                return 'The submitted data is invalid. Please review and try again.';
            case 429:
                return 'Too many requests were sent. Please wait and try again.';
            case 500:
                return 'An internal server error occurred. Please try again later.';
            case 502:
                return 'The server received an invalid response. Please try again later.';
            case 503:
                return 'The service is temporarily unavailable. Please try again later.';
            case 504:
                return 'The server took too long to respond. Please try again later.';
            default:
                return 'An unexpected error occurred.';
        }
    };

    private readonly normalizeMessage = (value: unknown): string | undefined => {
        if (typeof value === 'string') {
            const trimmedValue = value.trim();
            return trimmedValue || undefined;
        }

        return undefined;
    };
}
